import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { DialogShow } from "../../../components/DialogService/DialogService";

//PAGE
import P401List from "./P401List";
import P401Search from "./P401Search";
import P401Edit from "./P401Edit";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import ValidateService from "../../../components/ValidateService/ValidateService";
import { P401CreateData, P401GetData, P401GetDataList } from "../../../service/400/P401Service";
import { NullString } from "../../../utilities/NullUtil";

export default function P401() {

    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);
    const [action, setAction] = useState({ tab : 1, action : 'บันทึก'});
    const [textShow, setTextShow] = useState("");


    const [showDialog, setShowDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    // SEARCH
    const [searchData] = useState({
        searchWord: "",
        userId: dataUserSession()?dataUserSession().userId:'',
    });

    const [searchInfo, setSearchInfo] = useState({
        editUserId: "",
        userId: dataUserSession()?dataUserSession().userId:'',
    });

    const [searchWord, setSearchWord] = useState("");
    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onP401GetDataList();
    }, [searchData]);

    useEffect(() => {
        if(action.tab === 1){
            onP401GetDataList();
        }
    }, [action]);

    const onP401GetDataList = () => {
        setLoading(true);
        P401GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const submitFormSearch = (submitForm) => {

        setLoading(true);
        let newData = {
            userId: searchData.userId,
            searchWord:submitForm
        }

        P401GetDataList(newData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );

    };

    const submitForm = async (submitForm) => {

        let info = null
        let multiselectValue =[]

        let req = {
            editUserId: submitForm.userId,
            userId: searchInfo.userId,
        }
        setLoading(true);
        await P401GetData(req).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        index++;
                        if(element.selectedFlag === 'Y'){
                            multiselectValue.push(element.contractNo)
                        }
                    });

                    info = temp[0]

                }else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );

        if(info !== null){
            let newContract = "";
            if(multiselectValue && multiselectValue.length > 0){
                multiselectValue.forEach((item) =>{
                    newContract += newContract === ''?item:"|"+item;
                })

            }

            submitForm = {
                "actionCode": "U",
                "contractNo": newContract,
                "editUserId": info.userId,
                "password": info.password,
                "position": NullString(info.position),
                "telephone": info.telephone,
                "userId": searchData.userId,
                "userName": info.userName,
                "userRole": info.userRole,
                "userStatus": "I",
                "userSurname": info.userSurname,
                "workunitCode": info.workunitCode
            };


            setLoading(true);
            await P401CreateData(submitForm).then(
                (res) => {
                    setLoading(false);

                    if (res.status === 200) {
                        if(res.data[0].statusText === ''){

                            if(res.data[0].statusCode === 'C'){
                                setTextShow(`บันทึกสมบูรณ์ `);
                            }else if(res.data[0].statusCode === 'E'){
                                setTextShow(`มีข้อผิดพลาด`);
                            }
                        }else{
                            setTextShow(`${res.data[0].statusText}`);
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                    onP401GetDataList();
                },
                function (err) {
                    setLoading(false);
                    setErrData(err)
                }
            );
        }


    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onChangeAction = (tab = 1,act ='บันทึก')=>{
        setAction({
            action : act,
            tab : tab
        });
    }

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err ={errData} setErr ={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">


                    <div className="card">
                    {
                        (action && action.tab ===2)?
                            (
                            <>
                                {/* <h2 className="p-m-0">เพิ่ม/แก้ไข ข้อมูลผู้ใช้งาน</h2>
                                <hr/> */}
                                <P401Edit
                                    action ={action}
                                    onChangeAction = {onChangeAction}
                                    searchInfo = {searchInfo}

                                />
                            </>
                            )
                        :(
                            <>
                                {/* <h2 className="p-m-0">ข้อมูลผู้ใช้งาน</h2>
                                <hr/> */}
                                <P401Search setSearchWord={setSearchWord} searchWord={searchWord} submitForm={submitFormSearch} />
                                <P401List
                                    dataTable={dataTable}
                                    searchInfo={searchInfo}
                                    setSearchInfo={setSearchInfo}
                                    onChangeAction = {onChangeAction}
                                    submitForm = {submitForm}
                                    // setData = {setData}
                                />
                            </>
                        )
                    }
                    </div>

                </div>

                <DialogShow
                    visible={showDialog} header="แจ้งเตือน" modal
                    onHide={() => setShowDialog(false)} className="p-fluid"
                    textContent={textShow} btnCancle={() => setShowDialog(false)}
                />

            </div>
        </>
    );
}
